import React from "react";
import { FrontColors } from "../../../models/FrontColors";
import { FontQuicksand } from "../../BuildingBlocks/FontQuicksand";
import { FontSize } from "../../BuildingBlocks/FontSize";
import { TextColor } from "../../BuildingBlocks/TextColor";
import { WeightSemiBold } from "../../WeightSemiBold/WeightSemiBold";
import { WeightBold } from "../../WeightBold/WeightBold";

/**
 * The identity line shown in place of the contact fields once an introducer
 * contact is signed in.
 *
 * **When to use:** the property report form, when a session resolves to an
 * introducer. It replaces asking for the contact's email on every submission
 * and makes the attribution visible, so a contact can tell at a glance which
 * firm the report will be logged against.
 *
 * @example
 * <FPPropertyReportSignedInAs
 *     name="Chloe Fardah"
 *     email="chloe.fardah@dignityuk.co.uk"
 *     introducerName="Dignity"
 * />
 */
export const FPPropertyReportSignedInAs = (props: {
    name: string;
    email: string | null;
    introducerName: string;
}): JSX.Element =>
    <TextColor color={FrontColors.NEUTRAL_18}>
        <FontQuicksand>
            <FontSize
                size={16}
                lineHeight={1.3}
            >
                <WeightSemiBold>
                    Signed in as <WeightBold>{props.name.trim() !== "" ? props.name : props.email}</WeightBold>
                    {" · "}
                    <WeightBold>{props.introducerName}</WeightBold>
                </WeightSemiBold>
            </FontSize>
        </FontQuicksand>
    </TextColor>;
